import { Expose } from 'class-transformer';

export class OrganizationDto {
  @Expose()
  uuid: string;

  @Expose()
  name: string;

  @Expose()
  authId: number;
}
